import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import interactionTreeSlice from "./slices/InteractionTreeSlice";
import navSlice from "./slices/NavSlice";
import authSlice from "./slices/AuthSlice";
import tableSlice from "./slices/TableSlice";

const store = configureStore({
  reducer: {
    interactionTree: interactionTreeSlice.reducer,
    nav: navSlice.reducer,
    auth: authSlice.reducer,
    tables: tableSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

/* Needed for handing redux and redux-toolkit with TypeScript */
/* https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-state-type */
/* https://redux-toolkit.js.org/tutorials/typescript */

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Redux-Typescript Resources:
//  -- https://redux.js.org/usage/usage-with-typescript

// Redux Toolkit & Typescript Resources:
//  -- https://redux-toolkit.js.org/usage/usage-with-typescript

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<any>
>;
